import {
  Checkbox,
  List,
  Collapse,
  Slider,
  SliderSingleProps,
  Typography,
} from "antd";
import "../../product-component/productComponent.scss";
import React from "react";
import {
  AimOutlined,
  CaretDownOutlined,
  DeleteOutlined,
  MailFilled,
} from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const { Panel } = Collapse;

const marks: SliderSingleProps["marks"] = {
  0: { label: <small>AED15.00</small> },
  100: {
    label: <small>AED8,398.80</small>,
  },
};
const { Text } = Typography;
function CheckoutRightPenalComponent() {
  const [priceValue, setPriceValue] = React.useState([0, 100]);
  return (
    <>
      <div>
        <Collapse defaultActiveKey={1} className="eff-collapse mb-3">
          <Panel header={<span> <AimOutlined className="danger-color mr-1" /> Dubai Aquarium and Underwater Zoo</span>}  key="1">
            <List>
              <List.Item>
                <p>Tour Option </p>
                <p>DAUZ and Penguin Cove tickets</p>
              </List.Item>
              <List.Item>
                <p>Date</p>
                <p>6/3/2025</p>
              </List.Item>
              <List.Item>
                <p>Transfer Type</p>
                <p>Without Transfers</p>
              </List.Item>
              <List.Item>
                <p>Transfer Timings</p>
                <div className="text-right">
                  <p>The Aquarium will open at 10:00 AM </p>
                  <p>Ramadan timings wednesday - 10:00 am </p>
                  <p> - 12:00 midnight - Last entry 11:15 pm </p>
                  <p> Wednesday - 10:00 am - 01:00 - Last</p>
                </div>
              </List.Item>
              <List.Item>
                <p>Pax </p>
                <p>1 Adult</p>
              </List.Item>
              <List.Item>
                <Text type="danger">Last Date to Cancel </Text>
                <Text type="danger">Non Refundable</Text>
              </List.Item>
              <List.Item>
                <Text> Availability </Text>
                <Text>Availability</Text>
              </List.Item>
              <List.Item>
                <Text> Amount Incl. VAT </Text>
                <Text>AED 130.00</Text>
              </List.Item>
              <List.Item>
                <Text type="danger"> Redeemed R Points </Text>
                <Text type="danger">AED 10.00</Text>
              </List.Item>
              <List.Item>
                <Text> Total </Text>
                <Text>AED 120.00</Text>
              </List.Item>
            </List>
          </Panel>
        </Collapse>

        <Collapse defaultActiveKey={1} className="eff-collapse mb-3">
          <Panel header={<span> <AimOutlined className="danger-color mr-1" /> Dubai Delphinium</span>}  key="1">
            <List>
              <List.Item>
                <p>Tour Option </p>
                <p>Exotic Bird Show</p>
              </List.Item>
              <List.Item>
                <p>Date</p>
                <p>6/3/2025</p>
              </List.Item>
              <List.Item>
                <p>Transfer Type</p>
                <p>Without Transfers</p>
              </List.Item>
              <List.Item>
                <p>Transfer Timings</p>
                <div className="text-right">
                  <p>The Aquarium will open at 10:00 AM </p>
                  <p>Ramadan timings wednesday - 10:00 am </p>
                  <p> - 12:00 midnight - Last entry 11:15 pm </p>
                  <p> Wednesday - 10:00 am - 01:00 - Last</p>
                </div>
              </List.Item>
              <List.Item>
                <p>Pax </p>
                <p>1 Adult</p>
              </List.Item>
              <List.Item>
                <Text type="danger">Last Date to Cancel </Text>
                <Text type="danger">Non Refundable</Text>
              </List.Item>
              <List.Item>
                <Text> Availability </Text>
                <Text>Availability</Text>
              </List.Item>
              <List.Item>
                <Text> Amount Incl. VAT </Text>
                <Text>AED 130.00</Text>
              </List.Item>
              <List.Item>
                <Text type="danger"> Redeemed R Points </Text>
                <Text type="danger">AED 10.00</Text>
              </List.Item>
              <List.Item>
                <Text> Total </Text>
                <Text>AED 120.00</Text>
              </List.Item>
            </List>
          </Panel>
        </Collapse>
      </div>
    </>
  );
}

export default CheckoutRightPenalComponent;
